<template>
    <footer class="main-footer font-xs">
        <div class="row pb-30 pt-15">
            <div class="col-sm-6">
                <!-- <script>
                document.write(new Date().getFullYear())
                </script>  -->
               {{year}} © Bashundhara Ready Roti - Developed by <a href="https://www.sslwireless.com/" target="_blank">SSL Wireless</a>.
            </div>
            <!-- <div class="col-sm-6">
                <div class="text-sm-end">
                    All rights reserved
                </div>
            </div> -->
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>